import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx/govuk/components/button';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const UnableToProceedStaffOrFleetUsage = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const history = useHistory();

  useTitle(
    'landlordApp.UnableToProceedStaffOrFleetUsage.s4',
    'You cannot apply without staff or fleet parking spaces  - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const handleButtonClick = () => {
    history.push('/dashboardHub/dashboard');
  };

  const pageModel = (
    <div>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordApp.UnableToProceedStaffOrFleetUsage.s1',
          'Chargepoints can only be used by staff or fleet'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordApp.UnableToProceedStaffOrFleetUsage.s2',
          'To get this grant, the EV charging infrastructure and chargepoints you plan to install can only be for your staff or fleet vehicles.'
        )}
      </p>
      <div className="govuk-button-group govuk-!-margin-top-7">
        <Button onClick={handleButtonClick}>
          {copyProvider.getCopy(
            'landlordApp.UnableToProceedStaffOrFleetUsage.s3',
            'Manage your applications'
          )}
        </Button>
      </div>
    </div>
  );
  return pageModel;
};
export default UnableToProceedStaffOrFleetUsage;
